import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App'
import { initSentry } from './sentry'

// Initialize Sentry before the React root so the SDK is ready to capture
// any error thrown during initial render. No-op when VITE_SENTRY_DSN is
// unset (the dev/CI default).
initSentry()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
